var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39639 9.27958C5.26512 9.27984 5.1351 9.25419 5.01377 9.20408C4.89244 9.15397 4.78221 9.08039 4.68939 8.98758L0.447388 4.74458C0.351815 4.6524 0.275557 4.54211 0.223063 4.42014C0.17057 4.29817 0.142892 4.16697 0.141646 4.0342C0.140399 3.90142 0.165608 3.76972 0.215802 3.64679C0.265996 3.52386 0.34017 3.41216 0.433995 3.3182C0.52782 3.22424 0.639418 3.14991 0.762278 3.09954C0.885137 3.04918 1.0168 3.02378 1.14958 3.02484C1.28236 3.0259 1.41359 3.05339 1.53563 3.10571C1.65767 3.15803 1.76807 3.23413 1.86039 3.32958L5.39539 6.86458L11.7604 0.501577C11.9479 0.313936 12.2023 0.208468 12.4675 0.208374C12.7328 0.20828 12.9872 0.313569 13.1749 0.501077C13.3625 0.688585 13.468 0.942953 13.4681 1.20822C13.4682 1.47349 13.3629 1.72794 13.1754 1.91558L6.10339 8.98758C6.01057 9.08039 5.90033 9.15397 5.77901 9.20408C5.65768 9.25419 5.52765 9.27984 5.39639 9.27958Z",
    fill: "#2FAB73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.7a956ef33b88b60c5d271b1196ee992c.svg";
export { ForwardRef as ReactComponent };